<template>
  <div class="user_container">
    <div @click="goback" class="goback">
      <i class="el-icon-arrow-left"></i>
      <span>返回</span>
    </div>
    <div class="search">
      <el-cascader
        style="width: 48%"
        v-model="newValue"
        :options="columns"
        @change="handleChange"
        :props="defaultProps"
        :show-all-levels="false"
        popper-class="popper_class"
        clearable
      ></el-cascader>
    </div>
    <div class="rank_con">
      <div class="rank_item" @click="handleToBadgeList(topList[1])">
        <div class="con_item con_item1" v-if="topList[1]?.nickName">
          <div class="item_index">2</div>
          <div class="item_num">{{ topList[1]?.medalNumber }}枚</div>
          <div class="item_img">
            <img class="avatar" :src="topList[1]?.icon" alt="" />
          </div>
          <div class="name">{{ topList[1]?.nickName }}</div>
          <div class="dept">{{ topList[1]?.departmentName }}</div>
        </div>
      </div>
      <div class="rank_item" @click="handleToBadgeList(topList[0])">
        <div class="con_item" v-if="topList[0]?.nickName">
          <div class="item_index">1</div>
          <div class="item_num">{{ topList[0]?.medalNumber }}枚</div>
          <div class="item_img">
            <img class="img1" src="@/assets/newMedal/bg14.png" alt="" />
            <img class="avatar1" :src="topList[0]?.icon" alt="" />
          </div>
          <div class="name">{{ topList[0]?.nickName }}</div>
          <div class="dept">{{ topList[0]?.departmentName }}</div>
        </div>
      </div>
      <div class="rank_item" @click="handleToBadgeList(topList[2])">
        <div class="con_item con_item1" v-if="topList[2]?.nickName">
          <div class="item_index">3</div>
          <div class="item_num">{{ topList[2]?.medalNumber }}枚</div>
          <div class="item_img">
            <img class="avatar" :src="topList[2]?.icon" alt="" />
          </div>
          <div class="name">{{ topList[2]?.nickName }}</div>
          <div class="dept">{{ topList[2]?.departmentName }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <van-list
        v-if="historyList.length > 0"
        v-model="loadingOne"
        :finished="finishedOne"
        finished-text="没有更多了"
        @load="onLoadOne"
        loading-text="加载中，下拉查看更多"
        offset="10"
        :immediate-check="false"
      >
        <div
          class="list_con"
          v-for="(item, index) in historyList"
          :key="index"
          @click="handleToBadgeList(item)"
        >
          <div class="list_index">
            <div>{{ index + 4 }}</div>
            <div
              class="circle"
              v-if="$store.state.userInfo.username == item.userName"
            ></div>
          </div>
          <div class="list_item">
            <div class="item_left">
              <img class="avatar" :src="item.icon" alt="" />
              <div class="info_con">
                <div class="info_top">{{ item.nickName }}</div>
                <div class="info_bottom">{{ item.departmentName }}</div>
              </div>
            </div>
            <div class="list_num">{{ item?.medalNumber }}枚</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "rankList",
  props: {},
  components: {},
  data() {
    return {
      newText: "全部",
      newValue: "",
      columns: [],
      historyList: [],
      imgUrl: "",
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 20,
      showPickText: false,
      cascaderValue: "",
      defaultProps: {
        children: "child",
        // multiple: true,
        checkStrictly: true,
        value: "departmentCode",
        label: "departmentName",
        emitPath: false
        // expandTrigger: "hover"
      },
      topList: []
    };
  },
  created() {},
  mounted() {
    //获取图片地址
    this.imgUrl = api.imgUrl;
    //获取部门参数
    if (this.$route.query.newValue) {
      this.newValue = this.$route.query.newValue;
    } else {
      this.newValue = this.$store.state.userInfo.departmentCode.slice(0, 3);
    }
    this.queryClassification();
    this.queryProjectList();
    localStorage.removeItem("tabValue");
    // this.onLoadOne();
  },
  methods: {
    // 返回上一页
    goback() {
      this.$router.back();
    },
    //选择部门
    onFinish(value) {
      this.newText = value.selectedOptions.filter(
        item => item.value == value.value
      )[0].text;
      this.newValue = value.value;
      this.queryProjectList();
      this.showPickText = false;
    },
    //选择部门
    handleChange() {
      this.page = 1;
      if (!this.newValue) {
        this.newValue = this.$store.state.userInfo.departmentCode.slice(0, 3);
      }
      this.queryProjectList();
    },
    //获取部门列表
    queryClassification() {
      api.departmentToLevel().then(data => {
        this.columns = this.filterDeptList(data.data);
      });
    },
    //过滤部门列表
    filterDeptList(data) {
      const list = data?.filter(item => {
        item.text = item.departmentName ? item.departmentName : "";
        item.value = item.departmentCode ? item.departmentCode : "";
        item.child = this.filterDeptList(item.child);
        return item;
      });
      return list;
    },
    onLoadOne() {
      this.queryProjectList();
    },

    //查询排行榜列表
    queryProjectList() {
      api
        .queryRankingList({
          departmentCode: this.newValue,
          page: this.page,
          pageSize: this.pageSize
        })
        .then(res => {
          if (res.code == 200) {
            this.total = res.total;
            this.finishedOne = false;
            if (this.page === 1) {
              this.historyList = res.data.pageList;
            } else {
              this.historyList = this.historyList.concat(res.data.pageList);
            }
            if (this.historyList.length < this.total) {
              this.page = this.page + 1;
            } else {
              this.finishedOne = true;
            }
            this.topList = res.data.top;
            this.loadingOne = false;
          }
        });
    },
    //跳转荣誉墙
    handleToBadgeList(value) {
      this.$router.push({
        path: "/mobile/medal/myBadgeList",
        query: {
          token: value?.userName,
          nickName:value?.nickName,
          departmentName:value?.departmentName,
        }
      });
    }
  }
};
</script>
<style lang="scss">
.popper_class {
  width: 600px;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 12px; /* 设置滚动条高度 */
  }

  &::-webkit-scrollbar-thumb {
    background: #888; /* 滚动条滑块颜色 */
    border-radius: 4px; /* 滚动条滑块圆角 */
  }
}
</style>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg13.png");
  background-size: 100% 100%;
  .detail_title_info {
    width: 100%;
    height: 100%;
  }
}

.search {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: auto;
  .pick {
    width: 48%;
    height: 80px;
    border-radius: 20px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    margin-bottom: 15px;
    .newDate {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
    }
    div {
      color: #191b28;
      font-size: 30px;
    }
    i {
      color: #666666;
    }
  }
}
.rank_con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 80px;
  .rank_item {
    width: 33%;
  }
  .con_item1 {
    margin-top: 120px;
  }
  .con_item {
    // width: 100%;
    text-align: center;
    .item_index {
      color: #000000;
      font-size: 29px;
    }
    .item_num {
      color: #ff5c5c;
      font-size: 29px;
      margin: 22px 0;
    }
    .item_img {
      display: flex;
      flex-direction: column;
      align-items: center;
      .img1 {
        width: 85px;
        height: 45px;
        margin-bottom: -6px;
        position: relative;
        z-index: 1;
      }
      .avatar {
        width: 146px;
        height: 146px;
        border-radius: 50%;
        border: 6px solid #fff;
      }
      .avatar1 {
        width: 180px;
        height: 180px;
        border-radius: 50%;
        border: 6px solid #fff;
      }
    }
    .name {
      color: #191b20;
      font-size: 29px;
      margin: 22px 0;
    }
    .dept {
      color: #666666;
      font-size: 26px;
    }
  }
}
.content {
  overflow-y: auto;
  height: calc(100vh - 765px);
  margin-top: 30px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  border-radius: 40px 40px 0 0;
  ::v-deep {
    .van-list {
      // height: calc(100vh - 755px);
      // overflow-y: auto;
      // &::-webkit-scrollbar {
      //   display: none; /* Chrome Safari */
      // }
    }
  }
  .list_con {
    display: flex;
    align-items: center;
    margin-bottom: 36px;
    .list_index {
      width: 60px;
      color: #21242d;
      font-size: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      .circle {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ff5c5c;
        margin-top: 5px;
      }
    }
    .list_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      background: #fff;
      padding: 8px 12px;
      border-radius: 80px;
      .item_left {
        display: flex;
        align-items: center;
      }
      .avatar {
        width: 86px;
        height: 86px;
        border-radius: 50%;
        margin-right: 30px;
      }
      .info_con {
        .info_top {
          font-size: 26px;
          color: #191b20;
          margin-bottom: 10px;
        }
        .info_bottom {
          font-size: 22px;
          color: #666666;
        }
      }
      .list_num {
        color: #28ca6c;
        font-size: 30px;
        margin-right: 30px;
      }
    }
  }
}
::v-deep {
  .el-input__inner {
    height: 80px;
    line-height: 80px;
    font-size: 30px;
    color: #191b28;
    border-radius: 20px;
    border: 0;
  }
}
    .goback {
      display: flex;
      align-items: center;
      i {
        font-weight: bold;
        font-size: 48px;
        margin-right: 40px;
      }

      span {
        font-size: 34px;
      }
    }
</style>
